import * as React from "react"

import { cn } from "@/lib/utils"

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        // Plate & Hairline §02.2 + §17.2: a field is READ, not pressed, so
        // its radius is --ls-radius-0 (square) — square corners are what
        // distinguish a field from a button in a system with only two
        // interactive shapes (§17.2's forbidden list names this explicitly).
        // text-base (16px) is never stepped down at any breakpoint — §02.2
        // "16px prevents iOS zoom on focus" is a hard floor, not a default.
        // Height is the DS Field shell, 46px via --tls-field-h (hit area
        // stays >= 44). §02.2 padding is 12 top/bottom; with the 16px face
        // on a 20px line that is 12 + 20 + 12 + 2 = the 46 shell exactly.
        "file:text-[var(--tls-fg-strong)] placeholder:text-[var(--tls-fg-subtle)] selection:bg-brand selection:text-white flex min-h-[var(--tls-field-h)] w-full min-w-0 rounded-[var(--ls-radius-0)] border border-[color:var(--tls-border-subtle)] bg-[var(--tls-surface-elevated)] px-3 py-3 text-base leading-5 text-[var(--tls-fg-strong)] shadow-none outline-none transition-[border-color,background-color,color,box-shadow] duration-[var(--motion-duration-standard)] ease-[var(--motion-ease-standard)] file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
        "tlsr-focus",
        // §02.2 error state: a doubled inset border, never colour alone —
        // this system has no red (PRODUCT.md colour section: one accent,
        // no semantic green/amber). The 1px visible border plus a 1px inset
        // ink ring reads as "this field is doubly marked" without a hue.
        "aria-invalid:border-[color:var(--tls-fg-strong)] aria-invalid:shadow-[inset_0_0_0_1px_var(--tls-fg-strong)]",
        className
      )}
      {...props}
    />
  )
}

export { Input }
